import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  card: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderTopLeftRadius: "2pt",
    borderTopRightRadius: "2pt",
    borderBottomRightRadius: "2pt",
    borderBottomLeftRadius: "2pt",
    padding: "20pt",
    marginBottom: "20pt"
  },
  "card-row": {
    padding: "10pt 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start"
  },
  "card-col-label": {
    padding: 0,
    paddingRight: "10pt",
    width: "45%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
  "card-title": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "14pt",
    color: "#292d37",
    textTransform: "uppercase",
    textAlign: "right"
  },
  "card-row-title": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "16pt",
    color: "#063ac9"
  },
  "card-row-description": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16pt",
    color: "#8d98b5"
  },
  "card-row-value": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "20pt",
    color: "#063ac9"
  },
  "padding-top": {
    paddingTop: "16pt",
    alignItems: "flex-start"
  },
  "right-column": {
    width: "55%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
  low: {
    backgroundColor: "#DDFF2B"
  },
  medium: {
    backgroundColor: "#00AC46"
  },
  high: {
    backgroundColor: "#548235"
  },
  "low-text": {
    color: "#DDFF2B"
  },
  "medium-text": {
    color: "#00AC46"
  },
  "high-text": {
    color: "#548235"
  },
  afinity: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  value: {
    color: "#a0accf",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "20pt",
    paddingRight: "8pt"
  },
  status: {
    width: "22pt",
    height: "22pt",
    backgroundColor: "#a0accf",
    borderTopLeftRadius: "2pt",
    borderTopRightRadius: "2pt",
    borderBottomRightRadius: "2pt",
    borderBottomLeftRadius: "2pt",
    marginRight: "10pt"
  }
});
